var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],ref:"image",staticClass:"max-h-screen w-auto",attrs:{"src":_vm.blobUrl},on:{"load":_vm.loaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }